import DorsaImage from '@/components/dorsaImage/DorsaImage';
import { IMAGE_SHAPES, IMAGE_SIZES } from '@/components/dorsaImage/imageTypes';
import Link from 'next/link';
import React from 'react';
import AppInstallSticky from '@/components/AppInstallSticky';

function Header() {
    return (
        <header className="header max-w-[450px] mx-auto sticky top-0">
            <h1>
                <DorsaImage
                    src="/svg/dorsa-type-logo.svg"
                    config={{
                        size: IMAGE_SIZES.SIZE_1,
                        shape: IMAGE_SHAPES.HORIZONTAL
                    }}
                    className="header-logo"
                />
            </h1>
            <div className="header-second">
                <Link href="/search" className="header-second-btn">
                    <svg
                        width="30"
                        height="30"
                        className="header-second-btn-icon search-icon"
                        viewBox="0 0 30 30">
                        <path
                            d="M13.75 25.938c-6.725 0-12.187-5.463-12.187-12.188S7.025 1.563 13.75 1.563 25.938 7.025 25.938 13.75 20.475 25.938 13.75 25.938m0-22.5c-5.687 0-10.312 4.624-10.312 10.312S8.061 24.063 13.75 24.063s10.313-4.625 10.313-10.313c0-5.687-4.625-10.312-10.313-10.312"
                            className="handle-bar"></path>
                        <path
                            d="m24.984 27.968-.008-.002a1.74 1.74 0 0 1-.87-.382c-.329-.264-.695-.725-.969-1.543-.269-.807-.161-1.573.244-2.137.404-.56 1.103-.904 1.957-.904 1.16 0 1.947.44 2.282 1.081l.443-.231-.443.231c.342.656.282 1.558-.36 2.515l-.001.003c-.8 1.204-1.608 1.389-2.059 1.389q-.091-.001-.216-.02m1.889-3.454-.448.224zc-.124-.247-.368-.4-.602-.49a2.6 2.6 0 0 0-.933-.149c-.489 0-.949.16-1.235.534l-.006.007-.005.008c-.274.388-.27.895-.116 1.348.12.362.27.659.438.879.15.196.382.42.687.458.3.037.58-.117.775-.265.22-.166.445-.41.661-.723l.003-.004c.208-.309.336-.598.393-.859.054-.25.052-.518-.06-.744"
                            className="circle"></path>
                    </svg>
                </Link>
            </div>
        </header>
    );
}

export default Header;
